import { render, staticRenderFns } from "./editPhoto.vue?vue&type=template&id=bba3ab42&scoped=true"
import script from "./editPhoto.vue?vue&type=script&lang=js"
export * from "./editPhoto.vue?vue&type=script&lang=js"
import style0 from "./editPhoto.vue?vue&type=style&index=0&id=bba3ab42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba3ab42",
  null
  
)

export default component.exports